<template>

  <div class="page home">

    <!-- MAIN LANDING SECTION -->
  	<section id="landing">
    		<div class="container">
          <div class="col-sm-8 offset-md-1 offset-lg-1 col-md-10 col-lg-8">
            <transition name="slide-up-in" appear>
      				<h1>Hello. I'm Aaron and can help you design digital experiences that are beautiful, simple and just make sense!</h1>
            </transition>
    			</div>
    		</div>
  	</section>

    <section id="section-1">
      <div class="left-gradient container">
        <div class="col col-sm-4 col-md-4 col-lg-4">
          <div></div>
          <svg id="shape-circ-purple" width="426px" height="424px" viewBox="-2 -2 426 424" data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease">
            <path stroke="#C88EFF" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" d="M422,210 C422,325.975888 327.533644,420 210.998455,420 C94.4694465,420 0,325.975888 0,210 C0,94.0210354 94.4694465,0 210.998455,0 C327.533644,0 422,94.0210354 422,210 Z"></path>
          </svg>
          <svg id="shape-path-green" width="116px" height="119px" viewBox="0 0 116 119" data-sal="slide-up" data-sal-delay="450" data-sal-duration="600" data-sal-easing="ease">
            <path stroke-width="3" stroke="#6EFFAF" stroke-linecap="round" stroke-linejoin="round" d="M0,119 L116,0"></path>
          </svg>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease" class="col-xs-12 col-sm-12 offset-md-1 col-md-3 offset-lg-5 col-lg-2">
  					<h3>Skills</h3>
            <p>Interaction Design</p>
            <p>User Experience</p>
            <p>User Interface</p>
            <p>Data Visualisation</p>
            <p>Brand Identities</p>
  				</div>
          <div data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease" class="col-xs-12 col-sm-12 col-md-7 col-lg-4">
  					<h3 class="margin-top">What I Can Offer</h3>
            <p>Having worked with design agencies, budding entrepreneurs, to large companies across many different industries, I’ve obtained the art of really listening to business requirements.</p>
            <p>I help to craft simple and thoughtful designs that resonate with your audience. To apply an inventive creative vision to the design process and to help make information relevant through smart and engaging narratives.</p>
            <router-link class="nav" to="/about">Read More</router-link>
  				</div>
        </div>
      </div>
    </section>

  	<!-- WORKS LIST (SMALL) -->
  	<section id="works">

      <div data-sal="slide-up" data-sal-delay="300" data-sal-duration="600" data-sal-easing="ease" id="selected-works" class="container">
        <p>Selected Works</p>
        <div class="down-arrow"></div>
      </div>

      <ts-works-list></ts-works-list>
    </section>

    <ts-footer></ts-footer>

  </div>

</template>


<script>

// @ is an alias to /src
import TsWorksList from '@/components/TSWorksList.vue'
import TsFooter from '@/components/TSFooter.vue'
import sal from 'sal.js'

export default {

  name: 'Home',

  components: {
    TsWorksList,
    TsFooter
  },

  data() {
    return {

    }
  },

  mounted() {
    this.$root.$emit('show-shapes', true)
    sal({threshold: 0.10});
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#landing {
  h1 {
    animation-delay: 800ms;
  }
}

</style>
